"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { BaseProviderFormProps } from "@/components/settings/data-providers/provider-forms/base-provider-form";
import { InstructionsWrapper } from "@/components/settings/data-providers/provider-forms/instructions-wrapper";
import { FormInput } from "@/components/ui/input";
import { FormPasswordInput } from "@/components/ui/password-input";
import { FormMultiSelect } from "@/components/ui/select";
import { createCondition, WithCondition } from "@/components/ui/with-condition";
import { ProviderType } from "@/types/dataProvider";
export const RentvineProviderForm = t0 => {
  const $ = _c(49);
  const {
    form,
    isCreating,
    currentStep,
    providerData,
    isEditMode: t1
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== providerData?.vendorOptions) {
    t2 = providerData?.vendorOptions as {
      label: string;
      value: string;
    }[] || [];
    $[0] = providerData?.vendorOptions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const vendorOptions = t2;
  const vendorOptionsLoading = Boolean(providerData?.vendorOptionsLoading);
  const vendorOptionsError = typeof providerData?.vendorOptionsError === "string" ? providerData.vendorOptionsError : null;
  let t3;
  if ($[2] !== currentStep || $[3] !== isEditMode) {
    t3 = createCondition.or(createCondition.truthy(currentStep === 0), createCondition.truthy(isEditMode));
    $[2] = currentStep;
    $[3] = isEditMode;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li>Sign in to your Rentvine account.</li>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li>Check your browser URL and copy the subdomain before{" "}<code>.rentvine.com</code>.</li>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ol>{t4}{t5}<li>Enter that value as your database name (for example,{" "}<code>acme</code>).</li></ol>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isEditMode) {
    t7 = <InstructionsWrapper accordion={isEditMode} title="How to find your Rentvine database name:">{t6}</InstructionsWrapper>;
    $[8] = isEditMode;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== form || $[11] !== isCreating) {
    t8 = <FormInput autoComplete="off" disabled={isCreating} form={form} label="Database Name" name="data.credentials.databaseName" placeholder="Enter Database Name (e.g. acme)" type="text" />;
    $[10] = form;
    $[11] = isCreating;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t7 || $[15] !== t8) {
    t9 = <WithCondition condition={t3}>{t7}{t8}</WithCondition>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== currentStep || $[18] !== isEditMode) {
    t10 = createCondition.or(createCondition.truthy(currentStep === 1), createCondition.truthy(isEditMode));
    $[17] = currentStep;
    $[18] = isEditMode;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  let t12;
  if ($[20] !== form || $[21] !== isCreating) {
    t11 = <FormInput autoComplete="off" disabled={isCreating} form={form} label="Client ID" name="data.credentials.clientId" placeholder="Enter Client ID" type="text" />;
    t12 = <FormPasswordInput autoComplete="new-password" disabled={isCreating} form={form} label="Client Secret" name="data.credentials.clientSecret" placeholder="Enter Client Secret" type="password" />;
    $[20] = form;
    $[21] = isCreating;
    $[22] = t11;
    $[23] = t12;
  } else {
    t11 = $[22];
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12) {
    t13 = <WithCondition condition={t10}>{t11}{t12}</WithCondition>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== currentStep || $[29] !== isEditMode) {
    t14 = createCondition.or(createCondition.truthy(currentStep === 2), createCondition.truthy(isEditMode));
    $[28] = currentStep;
    $[29] = isEditMode;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      className: "w-full"
    };
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== form || $[33] !== isCreating || $[34] !== vendorOptions || $[35] !== vendorOptionsLoading) {
    t16 = <FormMultiSelect disabled={isCreating} form={form} isLoading={vendorOptionsLoading} label="General Work Order Vendors (optional)" loadingText="Loading vendors..." name={"data.credentials.generalWorkOrderVendorContactIds" as any} options={vendorOptions} placeholder="Select vendors" searchable={true} triggerProps={t15} />;
    $[32] = form;
    $[33] = isCreating;
    $[34] = vendorOptions;
    $[35] = vendorOptionsLoading;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== vendorOptionsError) {
    t17 = vendorOptionsError ? <p className="text-destructive text-sm" role="alert">{vendorOptionsError}</p> : null;
    $[37] = vendorOptionsError;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t16 || $[40] !== t17) {
    t18 = <div className="space-y-2">{t16}{t17}</div>;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t14 || $[43] !== t18) {
    t19 = <WithCondition condition={t14}>{t18}</WithCondition>;
    $[42] = t14;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t13 || $[46] !== t19 || $[47] !== t9) {
    t20 = <>{t9}{t13}{t19}</>;
    $[45] = t13;
    $[46] = t19;
    $[47] = t9;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  return t20;
};
(RentvineProviderForm as {
  providerType?: string;
}).providerType = ProviderType.RENTVINE;